export const domainsLogger = async _ref => {
  let httpClient = _ref.httpClient,
    request = _ref.request;
  const _await$import$Domains = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
      httpClient
    }),
    domainsLoggerBase = _await$import$Domains.domainsLoggerBase;
  try {
    await domainsLoggerBase(request);
    return {};
  } catch (error) {
    return {};
  }
};
//# sourceMappingURL=domainsLogger.js.map